export const ATTRIBUTES = {
    MAX_SIZE: 'max-size',
    INPUT_CAPTION: 'input-caption',
    ERROR_TEXT: 'error-text',
};

export const BYTES_IN_KB = 1024;
export const BYTES_IN_MB = BYTES_IN_KB * 1024;
